<script setup lang="ts">
import Experience from "./Experience.vue";
import type { ExperienceType } from "@/types";
import { useAttrs, computed } from "vue";

// Define props with optional itemsClass and required experiences
const props = defineProps<{
  experiences: ExperienceType[];
  itemsClass?: string;
}>();

// Access additional attributes passed to this component
const attrs = useAttrs();

/**
 * Marks consecutive roles at the same company while keeping each role's own
 * dates intact.
 */
const groupedExperiences = computed(() => {
  if (!props.experiences || !props.experiences.length) return [];

  const experiencesCopy = props.experiences.map(exp => ({ ...exp }));
  experiencesCopy.forEach((experience, index) => {
    const previousExperience = experiencesCopy[index - 1];
    experience.grouped = Boolean(
      previousExperience && experience.company === previousExperience.company
    );
  });

  return experiencesCopy;
});

/**
 * Filters out highlighted experiences that should not appear in this list.
 */
const nonHighlightedExperiences = computed(() =>
    groupedExperiences.value.filter((exp) => !exp.highlight)
);
</script>

<template>
  <div v-bind="attrs">
    <Experience
        v-for="experience in nonHighlightedExperiences"
        :key="experience.id"
        :experience="experience"
        class="cv-experience w-full border-l border-slate-200 pl-5 dark:border-slate-700 sm:pl-7"
        :class="itemsClass"
    />
  </div>
</template>

<style scoped>
</style>
